import React from 'react';
import ContactForm from './ContactForm';
import { useTranslation } from 'react-i18next';

const Content = () => {
  const { t } = useTranslation();
  return (
    <div className="mt-[63px] sm:mt-[78px] w-full px-5 sm:px-6 xl:px-8">
      <div className="max-w-[1140px] mx-auto w-full pt-10 md:pt-[92px] pb-[100px] flex items-start lg:items-center lg:flex-row flex-col justify-between gap-10 lg:gap-6">
        <div className="lg:max-w-[450px]">
          <h1 className="text-black text-[30px] sm:text-[40px] leading-[40px] sm:leading-[50px] font-normal libre-baskerville tracking-[-1.12px] uppercase">
            {t('contact.title')}
          </h1>
          <div className="mt-8 md:mt-14 lg:mt-20 space-y-2.5">
            <div className="border-b border-[#0000001A] pb-2.5">
              <div className="flex items-center gap-3 mb-2.5">
                <svg
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.3332 14.6V17.1C18.3341 17.3321 18.2866 17.5618 18.1936 17.7745C18.1006 17.9871 17.9643 18.178 17.7933 18.3349C17.6222 18.4918 17.4203 18.6112 17.2005 18.6856C16.9806 18.76 16.7477 18.7876 16.5165 18.7667C13.9522 18.488 11.489 17.6118 9.32486 16.2083C7.31139 14.9289 5.60431 13.2218 4.32486 11.2083C2.91651 9.03435 2.04007 6.55917 1.76653 3.98334C1.7457 3.7529 1.77309 3.52064 1.84695 3.30136C1.9208 3.08208 2.03951 2.88058 2.1955 2.70969C2.3515 2.5388 2.54137 2.40227 2.75302 2.30878C2.96468 2.21529 3.19348 2.16689 3.42486 2.16668H5.92486C6.32928 2.1627 6.72136 2.30591 7.028 2.56962C7.33464 2.83333 7.53493 3.19955 7.59153 3.60001C7.69705 4.40006 7.89274 5.18562 8.17486 5.94168C8.28698 6.23995 8.31125 6.56411 8.24478 6.87574C8.17832 7.18738 8.02392 7.47344 7.79986 7.70001L6.74153 8.75834C7.92783 10.8446 9.65524 12.572 11.7415 13.7583L12.7999 12.7C13.0264 12.476 13.3125 12.3216 13.6241 12.2551C13.9358 12.1886 14.2599 12.2129 14.5582 12.325C15.3143 12.6071 16.0998 12.8028 16.8999 12.9083C17.3047 12.9655 17.6744 13.1693 17.9386 13.4813C18.2029 13.7932 18.3433 14.1913 18.3332 14.6Z"
                    fill="#5B5B5B"
                  />
                </svg>
                <h3 className="text-[#5B5B5B] text-[14px] leading-[15px] font-normal uppercase">
                  {t('contact.phoneLabel')}
                </h3>
              </div>
              <a
                href="tel:+11234567890"
                className="text-[#000000] text-[24px] leading-[30px] font-normal tracking-[-1.12px]"
              >
                {t('contact.phoneValue')}
              </a>
            </div>

            <div className="border-b border-[#0000001A] pb-2.5">
              <div className="flex items-center gap-3 mb-2.5">
                <svg
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.0003 13.8334C11.8413 13.8334 13.3337 12.341 13.3337 10.5C13.3337 8.65907 11.8413 7.16669 10.0003 7.16669C8.15938 7.16669 6.66699 8.65907 6.66699 10.5C6.66699 12.341 8.15938 13.8334 10.0003 13.8334Z"
                    stroke="#5B5B5B"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M13.3337 7.16666V11.3333C13.3337 11.9964 13.5971 12.6323 14.0659 13.1011C14.5347 13.5699 15.1706 13.8333 15.8337 13.8333C16.4967 13.8333 17.1326 13.5699 17.6014 13.1011C18.0703 12.6323 18.3337 11.9964 18.3337 11.3333V10.5C18.3335 8.61918 17.6972 6.79372 16.5281 5.32043C15.3589 3.84715 13.7258 2.81268 11.8942 2.38524C10.0626 1.9578 8.14028 2.16253 6.43979 2.96613C4.7393 3.76974 3.36066 5.12495 2.52805 6.81143C1.69543 8.4979 1.45781 10.4164 1.85381 12.2551C2.24981 14.0937 3.25615 15.7444 4.70919 16.9385C6.16224 18.1327 7.97653 18.8003 9.85706 18.8326C11.7376 18.865 13.5738 18.2602 15.067 17.1167"
                    stroke="#5B5B5B"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <h3 className="text-[#5B5B5B] text-[14px] leading-[15px] font-normal uppercase">
                  {t('contact.emailLabel')}
                </h3>
              </div>
              <a
                href="mailto:support@zonetime.com"
                className="text-[#000000] text-[24px] leading-[30px] font-normal tracking-[-1.12px] uppercase"
              >
                {t('contact.emailValue')}
              </a>
            </div>

            <div className="border-b border-[#0000001A] pb-2.5">
              <div className="flex items-center gap-3 mb-2.5">
                <svg
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.0003 18.8334C14.6027 18.8334 18.3337 15.1024 18.3337 10.5C18.3337 5.89765 14.6027 2.16669 10.0003 2.16669C5.39795 2.16669 1.66699 5.89765 1.66699 10.5C1.66699 15.1024 5.39795 18.8334 10.0003 18.8334Z"
                    stroke="#5B5B5B"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M1.66699 10.5H18.3337"
                    stroke="#5B5B5B"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10.0003 2.16669C12.0847 4.44865 13.2693 7.41005 13.3337 10.5C13.2693 13.59 12.0847 16.5514 10.0003 18.8334C7.91593 16.5514 6.73136 13.59 6.66699 10.5C6.73136 7.41005 7.91593 4.44865 10.0003 2.16669Z"
                    stroke="#5B5B5B"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <h3 className="text-[#5B5B5B] text-[14px] leading-[15px] font-normal uppercase">
                  {t('contact.addressLabel')}
                </h3>
              </div>
              <h3 className="text-[#000000] text-[24px] leading-[30px] font-normal tracking-[-1.12px] uppercase">
                {t('contact.addressValue')}
              </h3>
            </div>
          </div>
        </div>
        <ContactForm />
      </div>
    </div>
  );
};

export default Content;
